import React, { FC, PropsWithChildren } from "react";
import Nav from "@/components/common/Nav";
import { use100vh } from "react-div-100vh";

const Container: FC<
  PropsWithChildren & {
    id?: string;
    showConnect?: boolean;
  }
> = ({ children, id, showConnect, ...props }) => {
  const height = use100vh();
  const connectShow = typeof showConnect === "undefined" ? true : showConnect;
  return (
    <div {...props} className="layout-content">
      <Nav showConnect={connectShow}></Nav>
      <div
        style={{
          height: height ? `${height - 60}px` : "calc(100vh-60px)",
        }}
        id={id}
        className="overflow-y-scroll overflow-x-hidden"
      >
        {children}
      </div>
    </div>
  );
};

export default Container;
